import { Injectable, Signal } from '@angular/core';
import { IDemographyData, IDemographyModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { DemographyActions, DemographySelectors, IDemographyState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class DemographyStore extends StateAccessService<IDemographyState> {
  readonly state$: Observable<IDemographyState>;

  readonly data$$: Signal<IDemographyData>;
  readonly model$$: Signal<IDemographyModel>;
  constructor() {
    super();
    this.model$$ = this.stateFacade.selectSignal$(DemographySelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(DemographySelectors.data);
  }

  dispatchDemographySubmit() {
    this.stateFacade.dispatch(DemographyActions.submit());
  }
  dispatchDemographySubmitSuccess({ model, data }: { model: IDemographyModel; data: IDemographyData }) {
    this.stateFacade.dispatch(DemographyActions.submitSuccess({ model, data }));
  }
}
